/* eslint-disable import/no-unresolved */
import { Chip, TableCell, TableRow, Tooltip } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import React, { useCallback } from 'react';
import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import { baseUrl } from 'src/constant/config';

// What the automatic recording is doing, as the admin should read it.
const RECORDING_STATUS = {
  idle: { label: 'Not recorded', color: 'default', help: 'Recording starts automatically when the debate is started and someone joins.' },
  waiting: { label: 'Waiting for participants', color: 'info', help: 'Recording starts as soon as someone joins the room.' },
  recording: { label: 'Recording', color: 'error', help: 'This debate is being recorded.' },
  processing: { label: 'Processing', color: 'warning', help: 'The debate has ended. The video appears in Recordings in a few minutes.' },
  ready: { label: 'In Recordings', color: 'success', help: 'The video is available in Recordings.' },
  failed: { label: 'Recording failed', color: 'error', help: 'Recording could not start.' },
};

function RecordingStatus({ recording }) {
  const status = RECORDING_STATUS[recording?.status] || RECORDING_STATUS.idle;
  const help = recording?.status === 'failed' && recording?.error ? `${status.help} ${recording.error}` : status.help;
  return (
    <Tooltip title={help} arrow>
      <Chip
        size="small"
        label={status.label}
        color={status.color}
        variant={recording?.status === 'recording' ? 'filled' : 'outlined'}
      />
    </Tooltip>
  );
}

function DebateRow({ inc, row, count, handelEditDebate, handelViewReqs, deleteTopic, deletingId, notify }) {
  const queryClient = useQueryClient();
  const { mutate, isLoading: toggling } = useMutation(
    async (variables) => {
      const { data } = await axios.put(
        `${baseUrl}/api/admin/startDebate`,

        variables
      );
      return data;
    },
    {
      onSuccess: (d) => {
        queryClient.refetchQueries('allDebtes');
        notify?.(d?.msg || 'Saved');
      },
      onError: (error) => {
        notify?.(error.response?.data?.msg || error.message, 'error');
      },
    }
  );
  const deleting = deletingId === row._id;

  const handelToggleDebate = useCallback(() => {
    mutate({
      debateId: row._id,
      roomId: row.roomId,
      isStarted: !row.isStarted,
    });
  }, [row, mutate]);

  return (
    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      <TableCell component="th" scope="row" className='one_line_text'>
        {count - inc}
      </TableCell>
      <TableCell component="th" scope="row" style={{ minWidth: '180px', maxWidth: '180px' }} className='one_line_text'>
        {row.title}
      </TableCell>
      <TableCell component="th" scope="row" style={{ minWidth: '180px', maxWidth: '380px' }} className='one_line_text'>
        {row.description}
      </TableCell>
      <TableCell component="th" scope="row" style={{ minWidth: '180px'}}>
        {new Date(row.startDate).toLocaleDateString()} {new Date(row.startDate).toLocaleTimeString()}
      </TableCell>
      <TableCell component="th" scope="row" style={{ minWidth: '100px'}}>
        {row.duration} mins
      </TableCell>
      <TableCell style={{ minWidth: '170px' }}>
        <RecordingStatus recording={row.recording} />
      </TableCell>
      <TableCell>
        <EditIcon sx={{ ':hover': { cursor: 'pointer' } }} onClick={() => handelEditDebate(row)} />
      </TableCell>
      {/* <TableCell >
        <PeopleAltIcon sx={{ ':hover': { cursor: 'pointer' } }} onClick={() => handelViewReqs(row)} />
      </TableCell> */}
      {/* <TableCell>
        <DeleteIcon sx={{ ':hover': { cursor: 'pointer' } }} onClick={() => deleteTopic(row._id)} />
      </TableCell> */}
      <TableCell id="bm-4" align="left" style={{ minWidth: '170px' }}>
        <LoadingButton
          variant="contained"
          size="small"
          color={row.isStarted ? 'error' : 'success'}
          onClick={handelToggleDebate}
          loading={toggling}
          disabled={toggling}
        >
          {row.isStarted ? `Stop` : `Start`}
        </LoadingButton>

        <LoadingButton
          variant="contained"
          size="small"
          color={'error'}
          onClick={() => deleteTopic(row._id)}
          loading={deleting}
          disabled={deleting}
          style={{ marginLeft: '10px' }}
        >
          Delete
        </LoadingButton>
      </TableCell>
    </TableRow>
  );
}

export default DebateRow;
